import script from "./Index.vue?vue&type=script&lang=ts&setup=true&name=StandardDialog"
export * from "./Index.vue?vue&type=script&lang=ts&setup=true&name=StandardDialog"

import "./Index.vue?vue&type=style&index=0&id=5c88bbaa&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c88bbaa"]])

export default __exports__